// ./config/headerText.js

export const languages = [
    { code: 'it', name: 'Italiano', flag: '🇮🇹' },
    { code: 'en', name: 'English', flag: '🇬🇧' },
    { code: 'de', name: 'Deutsch', flag: '🇩🇪' },
    { code: 'zh', name: '中文', flag: '🇨🇳' }
];

export const translations = {
    it: {
        title: 'Le avventure di Mars',
        mode: 'Modalità:',
        textAudio: 'Testo + Audio',
        onlyAudio: 'Solo Audio',
        language: 'Lingua:',
        volume: 'Volume Musica:',
        database: 'Database:',
        dbOnline: 'DB Online',
        dbLocal: 'DB Locale',
        logout: 'Esci',
        exeGreeting: 'Ciao! Io sono Mars',
        exeInstruction: 'Scegli un gioco per iniziare:',
        exeHidingGame: 'Nascondino',
        exeSyllables: 'Sillabe',
        exeNonWords: 'Non Parole',
        exeSentences: 'Frasi',
        nonWordsTitle: 'Esercizio Non Parole',
        nonWordsInstructions: 'Ripeti la non parola mostrata sullo schermo.',
        exerciseWords: {
            nonWords: [
                ['Trasvalvolare'], ['Sgrembiare'], ['Frattoscere'],
                ['Inzerbire'], ['Lompecare'], ['Grollinare'],
                ['Smarcugliare'], ['Trapendolare'], ['Fusteggiare'],
                ['Imbretolare'], ['Rastugnare'], ['Clavillare'],
                ['Strufolare'], ['Zantizzare'], ['Morfettare']
            ]
        },
        loginGreeting: 'Benvenuto! Io sono Mars',
        loginPlaceholder: 'Inserisci il tuo ID',
        loginButton: 'Continua',
        loginError: 'Inserisci un ID valido',
        loginConnectionError: 'Errore di connessione al server',
        loginRequestError: 'Errore nella richiesta',
        homeBanner: 'Tocca per cominciare',
        altMarsTitle: 'Titolo Mars',
        altMarsSubtitle: 'Sottotitolo Mars',
        altPlanet: 'Pianeta {color}',
        confirmExitText: 'Sei sicuro di voler abbandonare l\'esercizio?',
        confirmExitYes: 'Sì',
        confirmExitNo: 'No'
    },
    en: {
        title: 'Mars Adventures',
        mode: 'Mode:',
        textAudio: 'Text + Audio',
        onlyAudio: 'Only Audio',
        language: 'Language:',
        volume: 'Music Volume:',
        database: 'Database:',
        dbOnline: 'DB Online',
        dbLocal: 'DB Local',
        logout: 'Logout',
        exeGreeting: 'Hello! I am Mars',
        exeInstruction: 'Choose an exercise to start:',
        exeHidingGame: 'Hide and Seek',
        exeSyllables: 'Syllables',
        exeNonWords: 'Non-Words',
        exeSentences: 'Sentences',
        nonWordsTitle: 'NonWords Exercise',
        nonWordsInstructions: 'Repeat the non-word shown on the screen.',
        exerciseWords: {
            nonWords: [
                ['Transvalve'], ['Gremble'], ['Fractosce'],
                ['Inzerb'], ['Lompec'], ['Grolline'],
                ['Smarcul'], ['Trapendol'], ['Fusteg'],
                ['Imbretol'], ['Rastugn'], ['Clavill'],
                ['Strufol'], ['Zantizz'], ['Morfett']
            ]
        },
        loginGreeting: 'Welcome! I am Mars',
        loginPlaceholder: 'Enter your ID',
        loginButton: 'Continue',
        loginError: 'Please enter a valid ID',
        loginConnectionError: 'Server connection error',
        loginRequestError: 'Request error',
        homeBanner: 'Tap to start',
        altMarsTitle: 'Mars Title',
        altMarsSubtitle: 'Mars Subtitle',
        altPlanet: '{color} planet',
        confirmExitText: 'Are you sure you want to leave the exercise?',
        confirmExitYes: 'Yes',
        confirmExitNo: 'No'
    },
    de: {
        title: 'Mars Abenteuer',
        mode: 'Modus:',
        textAudio: 'Text + Audio',
        onlyAudio: 'Nur Audio',
        language: 'Sprache:',
        volume: 'Musiklautstärke:',
        database: 'Datenbank:',
        dbOnline: 'Online DB',
        dbLocal: 'Lokale DB',
        logout: 'Abmelden',
        exeGreeting: 'Hallo! Ich bin Mars',
        exeInstruction: 'Wähle eine Übung, um zu beginnen:',
        exeHidingGame: 'Versteckspiel',
        exeSyllables: 'Silben',
        exeNonWords: 'Nichtwörter',
        exeSentences: 'Sätze',
        nonWordsTitle: 'Nichtwörter-Übung',
        nonWordsInstructions: 'Wiederhole das angezeigte Nichtwort.',
        exerciseWords: {
            nonWords: [
                ['Transventilieren'], ['Grembeln'], ['Fraktoszieren'],
                ['Inzerben'], ['Lompeken'], ['Grollinieren'],
                ['Smarkulieren'], ['Trapendulieren'], ['Fusteggen'],
                ['Imbretolieren'], ['Rastugnieren'], ['Klavillieren'],
                ['Strufolieren'], ['Zantizieren'], ['Morfetten']
            ]
        },
        loginGreeting: 'Willkommen! Ich bin Mars',
        loginPlaceholder: 'Geben Sie Ihre ID ein',
        loginButton: 'Weiter',
        loginError: 'Bitte geben Sie eine gültige ID ein',
        loginConnectionError: 'Serververbindungsfehler',
        loginRequestError: 'Anfragefehler',
        homeBanner: 'Tippen um zu starten',
        altMarsTitle: 'Mars Titel',
        altMarsSubtitle: 'Mars Untertitel',
        altPlanet: '{color} Planet',
        confirmExitText: 'Sind Sie sicher, dass Sie die Übung verlassen möchten?',
        confirmExitYes: 'Ja',
        confirmExitNo: 'Nein'
    },
    zh: {
        title: '火星冒险',
        mode: '模式：',
        textAudio: '文本 + 音频',
        onlyAudio: '仅音频',
        language: '语言：',
        volume: '音乐音量：',
        database: '数据库：',
        dbOnline: '在线数据库',
        dbLocal: '本地数据库',
        logout: '退出',
        exeGreeting: '你好！我是 Mars',
        exeInstruction: '选择一个练习开始：',
        exeHidingGame: '捉迷藏',
        exeSyllables: '音节',
        exeNonWords: '无意义词',
        exeSentences: '句子',
        nonWordsTitle: '无意义词练习',
        nonWordsInstructions: '重复屏幕上显示的无意义词。',
        exerciseWords: {
            nonWords: [
                ['特拉斯瓦尔沃莱'], ['斯格伦比亚雷'], ['弗拉托斯切雷'],
                ['因泽比雷'], ['隆佩卡雷'], ['格罗利纳雷'],
                ['斯马尔库利亚雷'], ['特拉彭多拉雷'], ['福斯特贾雷'],
                ['因布雷托拉雷'], ['拉斯图尼亚雷'], ['克拉维拉雷'],
                ['斯特鲁福拉雷'], ['赞蒂扎雷'], ['莫尔费塔雷']
            ]
        },
        loginGreeting: '欢迎！我是 Mars',
        loginPlaceholder: '输入您的ID',
        loginButton: '继续',
        loginError: '请输入有效的ID',
        loginConnectionError: '服务器连接错误',
        loginRequestError: '请求错误',
        homeBanner: '点击开始',
        altMarsTitle: '火星标题',
        altMarsSubtitle: '火星副标题',
        altPlanet: '{color}星球',
        confirmExitText: '您确定要退出练习吗？',
        confirmExitYes: '是',
        confirmExitNo: '否'
    }
};

export const getTranslation = (languageCode) => {
    return translations[languageCode] || translations['it'];
};
